import { Link } from 'react-router-dom';

const About = () => {
  const features = [
    {
      icon: "🌟",
      title: "Erfahrung und Expertise",
      description: "Mit jahrelanger Erfahrung in der Branche kennen wir die Herausforderungen und Chancen, die Performer erwarten. Unsere Zusammenarbeit mit Plattformen wie Strip-Chat, myDirtyHobby und vielen anderen macht uns zu einem der führenden Netzwerke in Deutschland."
    },
    {
      icon: "🌟",
      title: "Rundum-Support",
      description: "Wir stehen dir zur Seite – von der Content-Produktion bis zur technischen Ausstattung. Unsere Studio-Wohnungen und unser exklusives Starterpaket bieten dir alles, was du brauchst, um sofort durchzustarten."
    },
    {
      icon: "🌟",
      title: "Einzigartiges Netzwerk",
      description: "Durch unsere engen Verbindungen zu Plattformen, Marken und Herstellern kannst du auf Vorteile zugreifen, die nur wenige Performer haben. Von Dessous bis zu Toys – wir bieten dir Qualität zu unschlagbaren Preisen."
    }
  ];

  const promises = [
    {
      title: "Partnerschaft auf Augenhöhe",
      description: "Dein Erfolg ist unser Erfolg. Wir arbeiten Hand in Hand mit dir zusammen."
    },
    {
      title: "Individuelle Betreuung",
      description: "Jeder Performer ist einzigartig. Wir passen unsere Unterstützung an deine Bedürfnisse an."
    },
    {
      title: "Qualität & Professionalität",
      description: "Von Equipment bis Beratung – bei uns steht Exzellenz im Mittelpunkt."
    }
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/95 to-deep-black -z-10"></div>
        <div className="absolute -top-1/2 right-0 w-3/4 h-full bg-gradient-to-bl from-hot-pink/20 to-accent-purple/20 blur-3xl animate-float"></div>
        <div className="absolute -bottom-1/2 left-0 w-3/4 h-full bg-gradient-to-tr from-neon-blue/20 to-hot-pink/20 blur-3xl animate-float" style={{ animationDelay: '-3s' }}></div>

        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6">
              Über Uns – <span className="text-gradient">Angel & Devil Network</span>
            </h1>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-playfair mb-8">
              Where <span className="text-hot-pink">Temptation</span> Meets <span className="text-accent-purple">Talent</span>
            </h2>
            <p className="text-lg sm:text-xl text-white/80 mb-8">
              Willkommen bei Angel & Devil Network, deiner Full-Service-Agentur für die Webcam-Branche! 
              Unser Ziel ist es, Talente wie dich auf ihrem Weg zum Erfolg zu begleiten und zu unterstützen – 
              mit einem einzigartigen Mix aus professioneller Betreuung, hochwertigem Equipment und einem starken Netzwerk.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-gradient-to-b from-deep-black to-deep-black/95">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black mb-8">
              Unsere <span className="text-gradient">Mission</span>
            </h2>
            <p className="text-lg sm:text-xl text-white/80">
              Wir glauben daran, dass jeder Performer das Beste aus seinen Fähigkeiten herausholen kann, 
              wenn die richtigen Ressourcen und Möglichkeiten zur Verfügung stehen. Egal, ob du gerade erst anfängst 
              oder bereits Erfahrung hast – wir sind dein Partner für Erfolg und Wachstum in der Webcam-Branche.
            </p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-gradient-to-b from-deep-black/95 to-deep-black">
        <div className="container-custom">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-center mb-12">
            Was uns <span className="text-gradient">auszeichnet</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="feature-card group">
                <div className="text-4xl mb-6 transform group-hover:scale-110 transition-transform duration-300">
                  {feature.icon}
                </div>
                <h3 className="text-gradient text-xl sm:text-2xl font-playfair mb-4">{feature.title}</h3>
                <p className="text-white/80">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Promise Section */}
      <section className="py-20 bg-gradient-to-b from-deep-black to-deep-black/95">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-center mb-12">
              Unser <span className="text-gradient">Versprechen</span> an dich
            </h2>
            <div className="space-y-8">
              {promises.map((promise, index) => (
                <div key={index} className="glass-effect rounded-2xl p-8 group hover:scale-105 transition-transform duration-300">
                  <h3 className="text-xl sm:text-2xl font-playfair text-gradient mb-4">{promise.title}</h3>
                  <p className="text-white/80">{promise.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-b from-deep-black/95 to-deep-black">
        <div className="container-custom">
          <div className="relative max-w-4xl mx-auto text-center">
            <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
            <div className="relative glass-effect rounded-2xl p-12">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-playfair mb-6">
                Angel & Devil Network
              </h2>
              <p className="text-xl sm:text-2xl text-white/90 mb-8">
                Werde Teil unseres Netzwerks und bringe deine Talente auf ein neues Level!
              </p>
              <div className="mt-8">
                <Link
                  to="/bewerbung"
                  className="bg-pink-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-pink-700 transition duration-300"
                >
                  Jetzt Durchstarten
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
